export default {
  name: 'dashify:NestedElements',
  title: 'Nested Elements',
  owner: 'System',
  solution: '',
  tags: ['html', 'element', 'nested'],
  createdAt: 'May 30, 2023, 10:14 AM',
  updatedAt: 'May 31, 2023, 11:14 AM',
  spec: {
    view: [
      [
        'ul',
        { '.': 'p-2 grid gap-3' },
        [
          ['li', { '.': 'border bg-green-800 p-2' }, 'task 1'],
          ['li', { '.': 'border bg-green-800 p-2' }, 'task 2'],
        ],
      ],
    ],
  },
};
